"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabNavigation = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
function TabNavigation({ tabs, className, onChange, activeTabIndex, }) {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)('w-full', 'flex', 'flex-row', 'border-b', 'bg-white', 'border-b-silver-30', className) }, { children: tabs.map((tab, index) => ((0, jsx_runtime_1.jsx)("button", Object.assign({ className: (0, classnames_1.default)('px-3', 'py-4', 'h-14', 'text-h200', 'font-bold', {
                'bg-white border-b-2 border-b-blue-80': index === activeTabIndex,
                'text-silver-50 hover:bg-silver-5 hover:text-blue-80 hover:border-b-2 hover:border-b-blue-80': index !== activeTabIndex,
            }), onClick: () => onChange(index) }, { children: tab }), `${index}-${tab}`))) })));
}
exports.TabNavigation = TabNavigation;
//# sourceMappingURL=TabNavigation.js.map